import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './ProductHowItWorks.css';

const leftVariants = {
  hidden: { opacity: 0, x: -80 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};
const rightVariants = {
  hidden: { opacity: 0, x: 80 },
  visible: { opacity: 1, x: 0, transition: { duration: 1.1, ease: [0.22, 1, 0.36, 1] } },
};

const ProductHowItWorks = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' });
  return (
    <section className="product-how-section" ref={ref}>
      <div className="product-how-container">
        <motion.div
          className="product-how-left"
          variants={leftVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <h2 className="product-how-title">Here's How Genix HR<br />Simplifies Healthcare</h2>
          <p className="product-how-desc">
            Smart tools tailored for hospitals and clinics — automate tasks, stay compliant, and manage your team effortlessly.
          </p>
          <a href="#" className="product-how-btn">Start free trial <span className="arrow">↗</span></a>
        </motion.div>
        <motion.div
          className="product-how-right"
          variants={rightVariants}
          initial="hidden"
          animate={isInView ? 'visible' : 'hidden'}
        >
          <div className="product-how-img-box">
            <img src="/images/GenixHr.png" alt="Genix HR Dashboard" className="product-how-img" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ProductHowItWorks; 